<template>
  <a-modal v-model="visible" width="888px" title="选择关联流程" @ok="onSubmit" @cancel="close">
    <a-transfer v-if="visible" :list-style="listStyle" :data-source="dataSource" show-search :filter-option="filterOption" :target-keys="targetKeys" :render="item => item.title" @change="handleChange" @search="handleSearch" />
    <a-alert class="alert-info" message="仅能关联状态为已完成且未被关联的流程" type="info" show-icon />
  </a-modal>
</template>
<script>
export default {
  name: 'WorkflowRelationFrom',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    },
    level: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      listStyle: {
        width: '400px',
        height: '400px'
      },
      targetKeys: []
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },

    getMock() {
      const targetKeys = [];
      const mockData = [];
      for (let i = 0; i < 20; i++) {
        const data = {
          key: i.toString(),
          title: `content${i + 1}`,
          description: `description of content${i + 1}`,
          chosen: Math.random() * 2 > 1
        };
        if (data.chosen) {
          targetKeys.push(data.key);
        }
        mockData.push(data);
      }
      this.mockData = mockData;
      this.targetKeys = targetKeys;
    },

    filterOption(inputValue, option) {
      return option.description.indexOf(inputValue) > -1;
    },

    handleChange(targetKeys) {
      this.targetKeys = targetKeys;
    },

    handleSearch(dir, value) {
      console.log('search:', dir, value);
    },

    onSubmit() {
      this.$emit('close', this.targetKeys);
    }
  }
};
</script>
<style lang="less" scoped>
.alert-info {
  margin-top: 16px;
}
</style>
